const cases = [
  {
    tag: "音乐节合作",
    title: "小蜜桃 × 城市青年音乐节",
    desc: "内容前置 + 现场共创 + 长尾运营，让一场音乐节的热度延续两周。",
    metric: "线上曝光 1200 万+",
    image:
      "https://readdy.ai/api/search-image?query=music%20festival%20crowd%20at%20sunset%2C%20orange%20spotlight%20beams%2C%20energetic%20outdoor%20stage%20scene%2C%20warm%20cinematic%20tone%2C%20editorial%20event%20photography&width=800&height=600&seq=xmt-case-1&orientation=landscape",
  },
  {
    tag: "生活方式内容",
    title: "小蜜桃 × 城市早餐计划",
    desc: "联合本地品牌共创早餐内容专栏，用真实故事连接用户的清晨。",
    metric: "专栏阅读 320 万+",
    image:
      "https://readdy.ai/api/search-image?query=beautiful%20breakfast%20table%20flatlay%2C%20warm%20morning%20light%2C%20orange%20juice%20and%20pastries%2C%20cream%20linen%20tablecloth%2C%20minimal%20editorial%20food%20photography&width=800&height=600&seq=xmt-case-2&orientation=landscape",
  },
  {
    tag: "品牌传播",
    title: "小蜜桃 × 新锐影视工作室",
    desc: "为工作室打造导演访谈系列，帮助品牌建立专业而有温度的形象。",
    metric: "系列播放 860 万+",
    image:
      "https://readdy.ai/api/search-image?query=film%20studio%20interview%20setup%2C%20warm%20cinematic%20lighting%2C%20camera%20and%20soft%20box%2C%20orange%20and%20cream%20tones%2C%20editorial%20behind%20the%20scenes%20photography&width=800&height=600&seq=xmt-case-3&orientation=landscape",
  },
];

export default function CaseGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-16 bg-background-100">
      <div className="max-w-2xl">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
          合作案例
        </h2>
        <p className="mt-2 text-sm md:text-base text-foreground-600">
          我们和不同领域的伙伴一起，做了一些还算有意思的事情。
        </p>
      </div>

      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {cases.map((item, idx) => (
          <article
            key={item.title}
            style={{ animationDelay: `${idx * 70}ms` }}
            className="group animate-fade-up bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors"
          >
            <div className="w-full h-48 overflow-hidden bg-background-200">
              <img
                src={item.image}
                alt={`${item.title} - 小蜜桃合作案例`}
                title={`${item.title} - 小蜜桃合作案例`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-5">
              <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 text-xs">
                {item.tag}
              </span>
              <h3 className="mt-3 font-heading font-semibold text-lg text-foreground-950">
                {item.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 line-clamp-2">{item.desc}</p>
              <p className="mt-4 text-sm text-primary-600 font-medium">{item.metric}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}